import { WidgetEnv } from "@xapp/stentor-chat-widget";
import { FC, useMemo } from "react";
import { Provider } from "react-redux";
import { ChatState } from "../../store/ChatState";
import { createStaticStore } from "../../store/StaticStore";
import { ChatWidgetUI, ChatWidgetMode } from "./ChatWidget";

export interface StaticChatWidgetContainerProps {
    readonly state?: ChatState;
    readonly mode?: ChatWidgetMode;
    readonly config: Omit<WidgetEnv, "connection">;
    readonly disableAutoScroll?: boolean;
    readonly preview?: boolean;
}

const StaticChatWidgetContainer: FC<StaticChatWidgetContainerProps> = (props) => {
    const { state } = props;

    const store = useMemo(() => {
        return createStaticStore(state);
    }, [state]);

    const config = useMemo<WidgetEnv>(() => {
        return {
            ...props.config,
            connection: {
                serverUrl: "",
                type: "local",
            },
        };
    }, [props.config]);

    return (
        <Provider store={store}>
            <ChatWidgetUI {...props} config={config} disableAutoScroll={props.disableAutoScroll} preview={props.preview} />
        </Provider>
    );
};

export default StaticChatWidgetContainer;
